import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CompleteSyllabusResponseManual } from '@edtech-ui/core/models/manual-course/manual-couse-payload';
import { CourseManagementService } from '@edtech-ui/core/services/course-management/course-management.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, of, Subscription } from 'rxjs';

@Component({
  selector: 'app-manual-course-view',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './manual-course-view.component.html',
  styleUrl: './manual-course-view.component.scss'
})
export class ManualCourseViewComponent implements OnInit ,OnDestroy{
  _syllabusData: CompleteSyllabusResponseManual['Data'] | null = null;
  classroomId: number | string | undefined;
  courseId: string | null = null;
  isLoading: boolean = true;
  subscription = new Subscription();

  constructor(
    private _courseService: CourseManagementService,
    private route: ActivatedRoute,
    private router: Router,
    private _toastr: ToastrService
  ) {}
  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.classroomId = params.get('classroomId') ?? '';
      this.courseId = params.get('courseId');

      if (this.courseId) {
        this.getManualCourseDetails(this.courseId);
      } else {
        this.isLoading = false;
        this._toastr.error('Course ID not found', 'Error');
      }
    });
  }


  getManualCourseDetails(courseId: string | number): void {
    this.isLoading = true;
	this.subscription.add(
    this._courseService.getManualCoursesByCourseId(courseId).subscribe({
      next: (response: CompleteSyllabusResponseManual) => {
        if (response.Success && response.Data) {
          this._syllabusData = response.Data;
        } else {
          this._toastr.warning('No course data available', 'Notice');
        }
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
        this._toastr.error('Failed to load course data', 'Error');
      }
    }));
  }

  goBack(): void {
    if (this.classroomId) {
      this.router.navigate(
        [
          '/student-dashboard',
          'classroom-detail-page',
          this.classroomId,
          'course'
        ],
        { replaceUrl: true }
      );
    } else {
	this.router.navigate(['/student-dashboard/classrooms']);
      this._toastr.error('Classroom ID not found!');
    }
  }

ngOnDestroy(): void {
	this.subscription.unsubscribe();
}

}
